function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "015---Astronaut",
  fill: "none",
  transform: "translate(-1)"
}, React.createElement("path", {
  id: "Shape",
  d: "m54.57 21.34c-3.8868944 7.0210816-10.9425375 11.7161423-18.92 12.59-1.1274938 4.8541218-3.4086028 9.3648864-6.65 13.15-1.9692465 2.1715134-3.0755108 4.9887523-3.11 7.92.0152907 2.0311215-1.4941116 3.7512381-3.51 4-1.1428448.1410941-2.2910582-.217181-3.1508703-.9831606s-1.3478064-1.8653506-1.3391297-3.0168394c.0013471-2.4707436.4765999-4.9182958 1.4-7.21l-4-1.82c-1.5160608 1.9994337-2.3534611 4.4310479-2.39 6.94.0129499 2.0654254-1.5125216 3.8180036-3.56 4.09-1.14284478.1410941-2.29105815-.217181-3.1508703-.9831606-.85981214-.7659796-1.3478064-1.8653506-1.3391297-3.0168394.0345005-4.8926518 1.86756211-9.6016625 5.15-13.23 2.1582943-2.5314211 3.7292348-5.5093778 4.6-8.72-2.8179589 2.6080216-6.3408551 4.3294763-10.13 4.95-.91127383.1478098-1.83985385-.1321722-2.51753799-.7590789-.67768414-.6269066-1.02899451-1.5309154-.95246201-2.4509211.14731736-1.4384357 1.25789676-2.5903005 2.69-2.79 3.46712974-.6644167 6.5659595-2.5878283 8.7-5.4.743467-1.1257172 2.1469061-1.6167163 3.43-1.2 0-.49 0-.91 0-1.25 21.47 3.66 21 3.5 21 3.6-.0239755.4636704.1770829.9104549.540019 1.2000105.3629361.2895555.8432182.3863541 1.289981.2599895 4.4507738-1.4483279 8.2017009-4.5039786 10.52-8.57.7713729-1.4254741 2.5355002-1.9805195 3.9841052-1.2535144 1.4486049.7270051 2.0578392 2.4731592 1.3758948 3.9435144z",
  fill: "#3f5c6c"
}), React.createElement("path", {
  id: "Shape",
  d: "m21.89 49c-7.7 0-8.92-4.56-9-4.76-.0721245-.2642362-.0327076-.5464907.1090472-.7808586.1417547-.2343679.3734379-.4003323.6409528-.4591414.5325786-.1327367 1.0726083.1886032 1.21.72.05.16 1 3.25 7 3.25.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z",
  fill: "#35495e"
}), React.createElement("path", {
  id: "Shape",
  d: "m19.89 43c-.5120317.0031062-.9436849-.3810651-1-.89-.5329493-5.3067627 1.4993538-10.5491386 5.47-14.11.1969526-.180366.4578684-.2744579.7246068-.2613088.2667383.013149.5171349.1324465.6953932.3313088.3690477.4090414.3377472 1.0395229-.07 1.41-3.5037421 3.1377344-5.298409 7.7600236-4.83 12.44.0222418.2770514-.0718261.550861-.2596389.7557477s-.4524247.3223642-.7303611.3242523z",
  fill: "#35495e"
}), React.createElement("path", {
  id: "Shape",
  d: "m27.89 40c-8.32 0-11.58-3.16-11.71-3.29-.1893127-.1877666-.2957983-.4433625-.2957983-.71s.1064856-.5222334.2957983-.71c.3900375-.3877236 1.0199625-.3877236 1.41 0 .06.05 2.94 2.71 10.3 2.71.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z",
  fill: "#35495e"
}), React.createElement("g", {
  fill: "#f0c419"
}, React.createElement("path", {
  id: "Shape",
  d: "m57 60c-.5522847 0-1-.4477153-1-1v-4c0-.5522847.4477153-1 1-1s1 .4477153 1 1v4c0 .5522847-.4477153 1-1 1z"
}), React.createElement("path", {
  id: "Shape",
  d: "m59 58h-4c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h4c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
}), React.createElement("path", {
  id: "Shape",
  d: "m42 46c-.5522847 0-1-.4477153-1-1v-4c0-.5522847.4477153-1 1-1s1 .4477153 1 1v4c0 .5522847-.4477153 1-1 1z"
}), React.createElement("path", {
  id: "Shape",
  d: "m44 44h-4c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h4c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
}), React.createElement("path", {
  id: "Shape",
  d: "m53 6c-.5522847 0-1-.44771525-1-1v-4c0-.55228475.4477153-1 1-1s1 .44771525 1 1v4c0 .55228475-.4477153 1-1 1z"
}), React.createElement("path", {
  id: "Shape",
  d: "m55 4h-4c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1h4c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1z"
})), React.createElement("path", {
  id: "Shape",
  d: "m10.71 33.81c-1.15013007.6372073-2.36329782 1.1533063-3.62 1.54-.061918-2.0253992-.54912996-4.0151319-1.43-5.84 1.20711312-.414072 2.35125562-.9928735 3.4-1.72.90510186 1.8920257 1.4639289 3.9308978 1.65 6.02z",
  fill: "#35495e"
}), React.createElement("path", {
  id: "Shape",
  d: "m51.13 26.11c-.991847 1.0983728-2.0831621 2.1026505-3.26 3-1.7345391-1.0577398-3.1242426-2.5968365-4-4.43 1.1196492-.814405 2.1488521-1.7463868 3.07-2.78 1.0665363 1.6972029 2.4978951 3.1353939 4.19 4.21z",
  fill: "#35495e"
}), React.createElement("path", {
  id: "Shape",
  d: "m25.89 55c.0152907 2.0311215-1.4941116 3.7512381-3.51 4-1.1428448.1410941-2.2910582-.217181-3.1508703-.9831606s-1.3478064-1.8653506-1.3391297-3.0168394c0-.34 0-.67 0-1 2.5363703-1.1789096 5.4636297-1.1789096 8 0 .11 0 0-.12 0 1z",
  fill: "#35495e"
}), React.createElement("path", {
  id: "Shape",
  d: "m12.9 52c-.0318888.3023051-.0485764.6060209-.05.91.0163186 2.048854-1.482397 3.7952205-3.51 4.09-1.14284478.1410941-2.29105815-.217181-3.1508703-.9831606-.85981214-.7659796-1.3478064-1.8653506-1.3391297-3.0168394 0-.33 0-.67 0-1 2.54107913-1.1574111 5.4589209-1.1574111 8 0z",
  fill: "#35495e"
}), React.createElement("path", {
  id: "Shape",
  d: "m37.58 27.09c-3.2017737 3.0745069-7.6718795 4.448452-12.0477567 3.7030344-4.3758771-.7454175-8.1389761-3.5218644-10.1422433-7.4830344.1464882.0179098.2906412.0514337.43.1 0-.49 0-.91 0-1.25 21.47 3.66 21 3.5 21 3.6-.0182537.551306.2757614 1.0658325.76 1.33z",
  fill: "#35495e"
}), React.createElement("path", {
  id: "Shape",
  d: "m13.89 15c0 7.7319865 6.2680135 14 14 14s14-6.2680135 14-14-6.2680135-14-14-14-14 6.2680135-14 14z",
  fill: "#2c3e50"
}), React.createElement("path", {
  id: "Shape",
  d: "m41.89 15c-.000739 4.9623499-2.6283116 9.5535222-6.9065346 12.0678262-4.278223 2.5143041-9.5677593 2.5760026-13.9034654.1621738-1.8177967-4.1595712-2.5704701-8.7065434-2.19-13.23 0 0 .1-.2.29-.55 1.36-2.37 7.59-11.4 20.82-5.52 1.2493059 2.1459134 1.9018585 4.5869437 1.89 7.07z",
  fill: "#f29c1f"
}), React.createElement("path", {
  id: "Shape",
  d: "m41.67 17.47c-.7984479 4.4507331-3.6973878 8.2417872-7.783371 10.1786108-4.0859833 1.9368235-8.8558506 1.7809107-12.806629-.4186108-1.8177967-4.1595712-2.5704701-8.7065434-2.19-13.23 0 0 .1-.2.29-.55 4.7 5.55 12.15 10.09 22.49 4.02z",
  fill: "#e57e25"
}), React.createElement("path", {
  id: "Shape",
  d: "m27.89 26c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1c3.5730906-.0016933 6.8067939-2.1169434 8.24-5.39.2383948-.4753879.8071695-.6810258 1.2944556-.4680046.487286.2130212.7226005.7701736.5355444 1.2680046-1.7508635 4.0009029-5.7027654 6.5871028-10.07 6.59z",
  fill: "#f3d55b"
}), React.createElement("circle", {
  id: "Oval",
  cx: 37.89,
  cy: 15,
  fill: "#f3d55b",
  r: 1
}));

var SvgAstronautWave = function SvgAstronautWave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 59 60",
    width: 512,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAstronautWave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/astronautWave.15beafde.svg";
export { ForwardRef as ReactComponent };